import { Link } from "react-router-dom";
import { Phone, Siren } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { useLang } from "@/lib/i18n";

const NUMBERS = [
  ["112", "National Emergency (Police / Ambulance / Fire)"],
  ["1091", "Women Helpline (Police)"],
  ["181", "Women Helpline (Domestic Abuse)"],
  ["1930", "Cyber Crime Helpline"],
];

export const EmergencyButton = ({ compact }) => {
  const { t } = useLang();
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button data-testid="emergency-sos-btn" className={`flex items-center gap-1.5 rounded-full bg-rose-600 text-white font-semibold hover:bg-rose-700 transition-colors ${compact ? "px-3 py-1.5 text-xs" : "px-5 py-3 text-sm"}`}>
          <Siren size={compact ? 14 : 18} /> SOS
        </button>
      </DialogTrigger>
      <DialogContent data-testid="emergency-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl">{t("emergency")}</DialogTitle>
          <DialogDescription>If you feel unsafe, move to a crowded public place and call for help immediately.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {NUMBERS.map(([n, l]) => (
            <a key={n} href={`tel:${n}`} data-testid={`emergency-call-${n}`} className="flex items-center justify-between rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 hover:bg-rose-100 transition-colors">
              <span className="text-sm text-slate-700">{l}</span>
              <span className="flex items-center gap-1 font-mono font-bold text-rose-700"><Phone size={14} />{n}</span>
            </a>
          ))}
        </div>
        <Link to="/support?type=emergency" data-testid="emergency-report-link" className="text-sm font-semibold text-[#0D5C46]">Send an urgent report to RentMyDate safety team →</Link>
      </DialogContent>
    </Dialog>
  );
};
